// Grantee map feature.
import {
    MapPinActiveIcon,
    MapPinHoverIcon,
    MapPinIcon,
    createIllinoisMap,
} from './index.js';

export default function granteeMap() {
    let map;
    const granteeMapWrapper = document.getElementById('grantee-map-wrapper');
    const granteeMap = document.getElementById('grantee-map');
    if (!granteeMapWrapper) return;

    Alpine.data('granteeMap', () => ({
        activePin: null,
        clearPins() {
            if (this.mapPins.length < 1) return;
            this.mapPins?.forEach((pin) => {
                if (!pin?.marker || pin.marker === null) return;
                pin.marker.map = null;
                pin.marker = null;
            });
            this.mapPins = [];
        },
        county: null,
        distance: null,
        fetchMap() {
            this.mapLoading = true;
            const endpoint = new URL(
                '/api/grantee/map',
                window.location.origin
            );
            if (this.county) {
                endpoint.searchParams.set('county', this.county);
            }
            if (this.validZip) {
                endpoint.searchParams.set('zip', this.zip);
            }
            if (this.validZip && this.zip !== '' && this.distance) {
                endpoint.searchParams.set('distance', this.distance);
            }
            fetch(endpoint.toString())
                .then((response) => response.json())
                .then((json) => this.placePins(json));
        },
        get hasFilters() {
            return this.county || this.distance || this.zip;
        },
        get highlightedPin() {
            return this.mapPins.find(({ id }) => id === this.activePin);
        },
        initApp() {
            this.fetchMap();
            this.$watch('county', () => this.fetchMap());
            this.$watch('distance', () => this.fetchMap());
            this.$watch('zip', () => this.fetchMap());
        },
        mapLoading: false,
        mapPins: [],
        async placePins(mapPins) {
            const { AdvancedMarkerElement } = await google.maps.importLibrary(
                'marker'
            );

            this.clearPins();
            this.$nextTick(() => {
                this.mapPins = mapPins.filter(
                    ({ address }) => address.lat && address.lng
                );
                // Place pins into the map.
                this.mapPins.forEach((pin) => {
                    pin.marker = new AdvancedMarkerElement({
                        position: {
                            lat: pin.address.lat,
                            lng: pin.address.lng,
                        },
                        map,
                        content: MapPinIcon(),
                        title: pin.title,
                    });

                    pin.marker.addListener('click', () => {
                        if (this.activePin) {
                            const previousPin = this.mapPins.find(
                                ({ id }) => id === this.activePin
                            );
                            previousPin.marker.content.classList.remove(
                                'active'
                            );
                        }
                        this.activePin = pin.id;
                        pin.marker.content.classList.add('active');
                    });
                });
            });

            this.mapLoading = false;
        },
        resetFilters() {
            this.county = null;
            this.distance = null;
            this.zip = null;
        },
        get validZip() {
            return (
                this.zip &&
                this.zip.length === 5 &&
                /(^\d{5}$)|(^\d{5}-\d{4}$)/.test(this.zip)
            );
        },
        zip: null,
        zoomIn() {
            map.setZoom(map.getZoom() + 1);
        },
        zoomOut() {
            map.setZoom(map.getZoom() - 1);
        },
    }));

    async function initMap() {
        map = await createIllinoisMap(google, granteeMap);
        window.dispatchEvent(new Event('map-loaded'));
    }

    initMap();
}
